import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const IframeListener: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const handler = (event: MessageEvent) => {
      if (event.data.type === 'pageChange') {
        navigate(event.data.url);
      }
      if (event.data.type === 'token') {
        navigate('/user/login');
      }
    };
    window.addEventListener('message', handler);
    return () => {
      window.removeEventListener('message', handler);
    };
  }, []);

  return null;
};

export default IframeListener;
